var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVimeoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 45",
    height: 24,
    id: "Layer_45",
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.665,8.39614l.65709.97s1.76033-1.4804,2.25287-.3129c1.68965,4.0051,2.10488,8.62912,3.91123,10.29435,2.00255,1.8461,4.2867-.59451,6.477-2.741,3.05615-2.995,6.94634-9.79371,3.97381-11.984-2.817-2.07569-6.696,1.52068-6.78388,3.736,1.5272-1.02627,3.27943.0063,2.30944,2.134-1.12681,2.47172-2.57035,4.244-3.0664,3.50446C10.67524,11.43126,11.301,5.29845,9.092,4.29718,6.9744,3.33737,2.665,8.39614,2.665,8.39614Z",
    style: {
      fill: "#ffffff"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVimeoIcon);
export default __webpack_public_path__ + "static/media/vimeo_icon.9004f14f8f12bf0d4d66ee3a3b4517d2.svg";
export { ForwardRef as ReactComponent };